import React from "react";
import { defineMessages, useIntl } from "react-intl";

import { usePassengerCbtGuestSearch } from "shared/hooks/passengerCbtGuestSearch";

import FormattedMessage from "@components/UI/FormattedMessage";
import SimpleSelect, { FormControl } from "@components/UI/SimpleSelect";

const { searchGuestPlaceholder } = defineMessages({
  searchGuestPlaceholder: {
    id: "PassengerCBTGuestSearch.placeholder",
  },
});

type PassengerCbtGuestSearchProps = {
  setShowCbtGuestSearchForm: (boolean) => void;
  indexGuest?: number;
};

export default function PassengerCbtGuestSearch({
  setShowCbtGuestSearchForm,
  indexGuest,
}: PassengerCbtGuestSearchProps) {
  const intl = useIntl();

  const {
    searchGuests,
    guestsOptions,
    onSelectFoundGuest,
  } = usePassengerCbtGuestSearch({
    setShowCbtGuestSearchForm,
  });

  const formatOptionLabel = ({ Email, FirstNameLatin, LastNameLatin }) => (
    <div style={{ display: "flex" }}>
      <div>
        {FirstNameLatin} {LastNameLatin}
      </div>
      <div style={{ marginLeft: "10px", color: "#ccc" }}>{Email}</div>
    </div>
  );

  return (
    <div>
      <div className="form-text-input-container form-text-input-container-search-guest">
        <span className="form-text-input-label required">
          <FormattedMessage id="PassengerCBTGuestSearch.label" />
        </span>
        <SimpleSelect
          placeholder={intl.formatMessage(searchGuestPlaceholder)}
          isClearable
          formatOptionLabel={formatOptionLabel}
          filterOption={() => true}
          testId={`custom-select-search-guest-${indexGuest}`}
          components={{ Control: FormControl }}
          styles={{
            container: (base) => ({
              ...base,
              flexGrow: 1,
            }),
          }}
          options={guestsOptions(indexGuest)}
          onInputChange={(searchText) => {
            searchGuests(searchText);
          }}
          onChange={(foundGuest) => {
            onSelectFoundGuest(foundGuest, indexGuest);
          }}
          isSearchable
        />
      </div>
      <div className="form-text-input-container form-text-input-container-search-guest">
        <span className="form-text-input-label form-text-input-uneditable-name-label" />
        <span
          id={`select-different-guest-${indexGuest}`}
          className="form-text-input-search-guest-new-label"
          onClick={() => setShowCbtGuestSearchForm(false)}
          role="button"
        >
          <FormattedMessage id="PassengerCBTGuestSearch.addNew" />
        </span>
      </div>
    </div>
  );
}
